var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h4",
                { staticClass: "modal-title", attrs: { id: "myModalLabel" } },
                [_vm._v(_vm._s(_vm.$t("actions.triggerModal.title")))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c(
                  "div",
                  { staticClass: "row no-gutters" },
                  _vm._l(_vm.store.definitions, function(definition) {
                    return _c(
                      "div",
                      {
                        key: definition.id,
                        staticClass:
                          "col-xl-2 col-lg-3 col-md4 col-sm-2 col-2 mr-2 mb-2",
                        staticStyle: { height: "5em" }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary w-100 h-100",
                            attrs: {
                              title: definition.description,
                              disabled: _vm.triggering
                            },
                            on: {
                              click: function($event) {
                                return _vm.trigger(definition)
                              }
                            }
                          },
                          [
                            _vm.triggering === definition
                              ? _c("Spinner")
                              : _vm._e(),
                            _vm._v(
                              "\n              " +
                                _vm._s(definition.name) +
                                "\n            "
                            )
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("TriggerModalDutySpecific", { ref: "dutySpecificModal" })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button" },
                  on: { click: _vm.dismiss }
                },
                [_vm._v(_vm._s(_vm.$t("btnClose")))]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }